import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './styles.module.scss';
import { Highlighted } from './highlighted-text';
import { getInitials } from '../../../engage/utils/get-initials';
export var UserInfo = function (props) {
    var avatarStyle = props.avatarUrl ? { backgroundImage: "url(".concat(props.avatarUrl, ")") } : {};
    return (_jsxs("div", { className: styles['user-info-container'], children: [_jsx("div", { className: styles.avatar, style: avatarStyle, children: !props.avatarUrl && getInitials(props.firstName, props.lastName) }), _jsxs("div", { className: styles['name-and-phone'], children: [_jsx("div", { className: styles['primary-label'], children: _jsx(Highlighted, { text: "".concat(props.firstName, " ").concat(props.lastName), highlight: props.searchString }) }), _jsx("div", { className: styles['secondary-label'], children: _jsx(Highlighted, { text: props.phone, highlight: props.searchString }) })] })] }));
};
UserInfo.defaultProps = {
    avatarUrl: '',
};
